var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.461l-2.135 5.56 1.226-.197 4.572-.66-1.465-1.881c3.133-2.173 7.454-1.536 9.773 1.44 2.411 3.096 1.821 7.649-1.308 10.086-3.128 2.437-7.687 1.895-10.098-1.201a7.117 7.117 0 01-1.442-5.263L7.67 15.24a8.303 8.303 0 001.685 6.118c2.813 3.611 8.132 4.244 11.782 1.4 3.65-2.842 4.338-8.154 1.525-11.766-2.717-3.489-7.79-4.22-11.445-1.65L9.75 7.462z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.ebe20c00.svg";
export { ForwardRef as ReactComponent };